import { getCountryCodeByName } from "@/constants/countries";

/**
 * Formats a phone number according to a mask pattern
 * @param phone - The phone number to format
 * @param mask - The mask pattern to apply (e.g., "(99) 99999-9999")
 * @returns A formatted phone number string
 */
export const formatPhoneWithMask = (phone: string, mask: string): string => {
  const digits = phone.replace(/\D/g, '');
  let result = '';
  let digitIndex = 0;

  for (let i = 0; i < mask.length && digitIndex < digits.length; i++) {
    if (mask[i] === '9') {
      result += digits[digitIndex];
      digitIndex++;
    } else {
      result += mask[i];
    }
  }

  return result;
};

/**
 * Formats a phone number for API submission by ensuring it has the correct country code
 * @param phoneValue - The phone number to format
 * @param country - The country name to get the country code from
 * @returns A formatted phone number with country code (e.g., +5511999999999)
 */
export const formatPhoneForAPI = (phoneValue: string, country: string): string => {
  if (!phoneValue) return "";

  // Remove all non-digit characters from the phone value
  const digits = phoneValue.replace(/\D/g, '');

  // Get the country code
  const countryCode = getCountryCodeByName(country);
  const countryCodeDigits = countryCode.replace('+', '');

  // If the phone number already starts with the country code, return as is
  if (digits.startsWith(countryCodeDigits)) {
    return `+${digits}`;
  }

  // Otherwise, prepend the country code
  return `+${countryCodeDigits}${digits}`;
};
